import { GRID_CHECKBOX_SELECTION_COL_DEF, GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from '@mui/x-data-grid-pro'

export const DATA_GRID_DEFAULT_PINNED_COLUMNS = {
  left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, GRID_DETAIL_PANEL_TOGGLE_COL_DEF.field],
  right: ['actions'],
}
